import React from "react";
import { MEDIA } from "../../config/site";
import { Reveal, useEnquiry } from "../../lib/site-ui";

export const FreeDemo = () => {
  const { openEnquiry } = useEnquiry();
  return (
    <section id="demo" className="relative isolate overflow-hidden" data-testid="free-demo-section">
      <div className="absolute inset-0 -z-10">
        <img src={MEDIA.cockpit} alt="Airliner cockpit instruments — DGCA exam preparation with AeroVaid" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-slate-950/85" />
      </div>
      <div className="max-w-4xl mx-auto px-4 sm:px-8 py-24 sm:py-32 lg:py-40 text-center">
        <Reveal as="p" className="label-mono text-slate-400 mb-6">Free Demo Class</Reveal>
        <Reveal as="h2" className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight text-white">
          Not Sure Which Coaching Is Right for You?
        </Reveal>
        <Reveal className="mt-6 text-lg text-slate-300 max-w-2xl mx-auto leading-relaxed">
          Attend a FREE Demo Class and experience the AeroVaid teaching approach before you enrol.
        </Reveal>
        <Reveal delay={0.1}>
          <button
            data-testid="free-demo-btn"
            onClick={() => openEnquiry()}
            className="mt-9 bg-white text-slate-950 font-semibold px-9 py-4 rounded-sm hover:bg-slate-200 transition-all hover:scale-[1.02] text-sm tracking-wide"
          >
            GET YOUR FREE DEMO CLASS
          </button>
        </Reveal>
        <Reveal className="mt-6 text-slate-400 text-sm">
          No commitment. Speak directly with the instructor and understand the course before joining.
        </Reveal>
      </div>
    </section>
  );
};
